import { render, staticRenderFns } from "./Typologies.vue?vue&type=template&id=4578c724&"
import script from "./Typologies.vue?vue&type=script&lang=js&"
export * from "./Typologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports